import {dateOnlyInputValue,londonDateTimeInputInstant} from '../dates';

export type CalendarLens='agenda'|'month'|'week'|'year';
export function calendarLens(value:string|null):CalendarLens{return value==='month'||value==='week'||value==='year'?value:'agenda';}
export function calendarAnchor(value:string|null,month:string,today:string){
 return value&&dateOnlyInputValue(value)&&value.startsWith(month)?value:today.startsWith(month)?today:`${month}-01`;
}
export function calendarWindow(lens:CalendarLens,month:string,day:string){
 const selected=new Date(`${month}-01T00:00:00Z`);
 const start=new Date(selected),end=new Date(selected);
 if(lens==='year'){start.setUTCMonth(0);end.setUTCFullYear(end.getUTCFullYear()+1,0,1);}
 else if(lens==='week'){
  if(dateOnlyInputValue(day)&&day.startsWith(month))start.setUTCDate(Number(day.slice(-2)));
  start.setUTCDate(start.getUTCDate()-((start.getUTCDay()+6)%7));end.setTime(start.getTime());end.setUTCDate(end.getUTCDate()+7);
 }else {start.setUTCMonth(start.getUTCMonth()-1);end.setUTCMonth(end.getUTCMonth()+7);}
 const midnight=(value:Date)=>londonDateTimeInputInstant(`${value.toISOString().slice(0,10)}T00:00`)!;
 return {from:midnight(start),to:midnight(end)};
}
